import React from 'react'
import {updateState} from '../helpers/react-helpers'
import * as kb from '../kb'
import {ajax, postJson, resolveRoute} from '../helpers/ajax'
import RDS from 'react-dom/server'
import Icon from './Icon'
import ErrorMessage from './ErrorMessage'
import AddressAutocomplete from './AddressAutocomplete'
import ActionLink from './ActionLink'
import icons from '../../markons/markons'
import ButtonRow from './ButtonRow'
import AioSelect from './aio-inputs/AioSelect'
import {GridCol, GridRow, GridSection, HelpText} from './grid-form'
import AioText from './aio-inputs/AioText'
import AioPhoneNumber from './aio-inputs/AioPhoneNumber'
import AioTextArea from './aio-inputs/AioTextArea'
import styles from './Stop.less'
import AioPhoneOnly from './aio-inputs/AioPhoneOnly'
import CheckboxLabel from './CheckboxLabel'
import {uuid} from '../util/random'
import {mergeIn} from '../util/collections'
import {COUNTRY_LIST} from '../data/countries'

function fixData(formData: any) {
    return {
        ...formData,
        notes: formData.notes || '',
        mail_address: formatAddress({
            placeName: formData.mail_place_name,
            streetAddress: formData.mail_street,
            city: formData.mail_city,
            postalCode: formData.mail_postal_code,
            province: formData.mail_province,
            country: formData.mail_country,
        })
    }
}

type State = any;

type Props = {
    formData?: any;
    customerId?: number;
    phoneTypes: any[];
    companies?: any[];
    afterSave?: (...args: any[]) => any;
    onCancel?: (...args: any[]) => any;
    googleMapsApiKey: string;
};

export default class CustomerForm extends React.Component<Props, State> {

    uuid: any;

    constructor(props: any) {
        super(props);
        this.state = {
            formData: {
                id: this.props.customerId,
                first_name: '',
                last_name: '',
                company: '',
                email: '',
                pri_phone_type: 'CELL',
                pri_phone_number: '',
                sec_phone_type: 'HOME',
                sec_phone_number: '',
                fax_number: '',
                company_id: '',
                mail_place_name: '',
                mail_street: '',
                mail_city: '',
                mail_postal_code: '',
                mail_province: '',
                mail_country: '',
                notes: '',
                exclude_customer_survey: 0
            },
            splitAddress: false,
        };
        if (props.formData) {
            Object.assign(this.state.formData, fixData(props.formData))
        }
        this.uuid = uuid();
    }

    componentDidMount() {
        if (this.props.customerId) {
            this.setState({loading: true});
            ajax(resolveRoute('getCustomer', {id: this.props.customerId})).then((res: any) => {
                if (res.ok) {
                    updateState.call(this, {formData: {$apply: (formData: any) => fixData(mergeIn(res.data)(formData))}});
                }
            }).finally(() => {
                this.setState({loading: false});
            })
        }
    }

    render() {
        const {formData, loading} = this.state;

        return (
            <div className="grid-form">
                <GridSection>
                    {this.props.companies ?
                        <GridRow>
                            <GridCol superUser>
                                <AioSelect label="Customer of (company)" placeholder="— Please Select —"
                                           disabled={loading} loading={loading} value={formData.company_id}
                                           onChange={this.update('company_id')}
                                           options={this.props.companies.map((company: any) => [company.id, company.name])}/>
                            </GridCol>
                        </GridRow> : null}
                    <GridRow>
                        <GridCol minWidth={180}>
                            <AioText label="First Name" icon={icons.faUser} value={formData.first_name}
                                     disabled={loading} loading={loading} onChange={this.update('first_name')}/>
                        </GridCol>
                        <GridCol minWidth={180}>
                            <AioText label="Last Name" icon={icons.faUser} value={formData.last_name} disabled={loading}
                                     loading={loading} onChange={this.update('last_name')}/>
                        </GridCol>
                    </GridRow>
                    <GridRow>
                        <GridCol minWidth={180}>
                            <AioText label="Company" icon={icons.faBuilding} value={formData.company} disabled={loading}
                                     loading={loading} onChange={this.update('company')}/>
                        </GridCol>
                        <GridCol minWidth={180}>
                            <AioText label="Email address(es)" icon={icons.faEnvelope} value={formData.email}
                                     disabled={loading} loading={loading} onChange={this.update('email')}/>
                            <HelpText>Separate multiple email addresses with a comma.</HelpText>
                        </GridCol>
                    </GridRow>
                    <GridRow>
                        <GridCol minWidth={290} flex={2}>
                            <AioPhoneNumber label="Primary Phone Number" numberValue={formData.pri_phone_number}
                                            numberOnChange={this.update('pri_phone_number')} disabled={loading}
                                            loading={loading} typeValue={formData.pri_phone_type}
                                            typeOnChange={this.update('pri_phone_type')}
                                            typeOptions={this.props.phoneTypes}/>
                        </GridCol>
                        <GridCol minWidth={290} flex={2}>
                            <AioPhoneNumber label="Secondary Phone Number" numberValue={formData.sec_phone_number}
                                            numberOnChange={this.update('sec_phone_number')} disabled={loading}
                                            loading={loading} typeValue={formData.sec_phone_type}
                                            typeOnChange={this.update('sec_phone_type')}
                                            typeOptions={this.props.phoneTypes}/>
                        </GridCol>
                        <GridCol minWidth={200} flex={1}>
                            <AioPhoneOnly label="Fax Number" icon={icons.faFax} value={formData.fax_number}
                                     disabled={loading} loading={loading} onChange={this.update('fax_number')}/>
                        </GridCol>
                    </GridRow>

                    <GridRow>
                        {this.state.splitAddress ?
                            <GridCol relative>
                                <GridSection>
                                    <GridRow>
                                        <GridCol style={{minWidth: '180px'}}>
                                            <AioText label="Place Name" value={formData.mail_place_name}
                                                onChange={this.update('mail_place_name')}/>
                                        </GridCol>
                                        <GridCol style={{minWidth: '180px'}}>
                                            <AioText label="Street Address" value={formData.mail_street}
                                                     onChange={this.update('mail_street')}/>
                                        </GridCol>
                                        <GridCol style={{minWidth: '180px'}}>
                                            <AioText label="City" value={formData.mail_city}
                                                onChange={this.update('mail_city')}/>
                                        </GridCol>
                                    </GridRow>
                                    <GridRow>

                                        <GridCol style={{minWidth: '180px'}}>
                                            <AioText label="State/Province" value={formData.mail_province}
                                                     onChange={this.update('mail_province')}/>
                                        </GridCol>
                                        <GridCol minWidth={180}>
                                            <AioSelect placeholder="— Not Selected —" label="Country" value={formData.mail_country}
                                                onChange={this.update('mail_country')} options={COUNTRY_LIST}/>
                                        </GridCol>
                                        <GridCol style={{minWidth: '100px'}}>
                                            <AioText label="Zip/Postal Code" value={formData.mail_postal_code}
                                                     onChange={this.update('mail_postal_code')}/>
                                        </GridCol>
                                    </GridRow>
                                </GridSection>

                                <ActionLink className={styles.autocompleteLink} onClick={this.useAutocomplete}>Turn
                                    Autocomplete On</ActionLink>
                            </GridCol>
                            :
                            <GridCol style={{position: 'relative'}}>
                                <AddressAutocomplete value={formData.mail_address} onChange={this.addressChanged}
                                                     onPlaceChanged={this.placeChanged}
                                                     googleMapsApiKey={this.props.googleMapsApiKey}/>
                                <ActionLink className={styles.autocompleteLink} onClick={this.splitAddress}>Turn
                                    Autocomplete Off</ActionLink>
                            </GridCol>
                        }
                    </GridRow>

                    <GridRow>
                        <GridCol>
                            <AioTextArea label="Notes" value={formData.notes} disabled={loading} loading={loading}
                                         onChange={this.update('notes')}/>
                        </GridCol>
                    </GridRow>

                    <GridRow>
                        <GridCol>
                            <CheckboxLabel
                              checked={formData.exclude_customer_survey}
                              onChange={this.update('exclude_customer_survey')}
                            >Exclude from receiving follow-up email</CheckboxLabel>
                        </GridCol>
                    </GridRow>
                </GridSection>
                <ButtonRow>
                    <ButtonRow.Left>
                        <button type="submit" className="btn btn-save" onClick={this.save} disabled={loading}><Icon
                            name={icons.miscSave}/> Save
                        </button>
                    </ButtonRow.Left>
                    <ButtonRow.Right>
                        <a className="btn btn-default" onClick={this.cancel}><Icon
                            name={icons.ionBackspaceOutline}/> Discard Changes</a>
                        {formData.id ? <a className="btn btn-cancel" onClick={this.deleteCustomer}><Icon
                            name={icons.ionTrashA}/> Delete Customer</a> : null}
                    </ButtonRow.Right>
                </ButtonRow>
            </div>
        );
    }

    splitAddress = () => {
        this.setState({
            splitAddress: true
        });
    };

    useAutocomplete = () => {
        const {formData} = this.state;
        updateState.call(this, {
            splitAddress: {$set: false},
            formData: {
                mail_address: {
                    $set: formatAddress({
                        placeName: formData.mail_place_name,
                        streetAddress: formData.mail_street,
                        city: formData.mail_city,
                        postalCode: formData.mail_postal_code,
                        province: formData.mail_province,
                        country: formData.mail_country,
                    })
                }
            }
        })
    };

    addressChanged = (ev: any) => {
        updateState.call(this, {
            formData: {
                mail_address: {$set: ev.target.value},
                mail_place_name: {$set: ''},
                mail_street: {$set: ''},
                mail_city: {$set: ''},
                mail_postal_code: {$set: ''},
                mail_province: {$set: ''},
                mail_country: {$set: ''},
            }
        });
    };

    placeChanged = (place: any) => {
        updateState.call(this, {
            formData: {
                mail_address: {$set: formatAddress(place)},
                mail_place_name: {$set: place.placeName},
                mail_street: {$set: place.streetAddress},
                mail_city: {$set: place.city},
                mail_postal_code: {$set: place.postalCode},
                mail_province: {$set: place.province},
                mail_country: {$set: place.countryShort},
            }
        });
    };

    update = (field: any) => (ev: any) => {
        updateState.call(this, {
            formData: {
                [field]: {$set: field === 'exclude_customer_survey' ? ev.target.checked : ev.target.value},
            }
        });
    };

    cancel = (ev: any) => {
        ev.preventDefault();
        if (this.props.onCancel) {
            this.props.onCancel();
        } else {
            if (this.state.formData.id) {
                kb.navigate(resolveRoute('customers.show', {id: this.state.formData.id}));
            } else {
                kb.navigate(resolveRoute('customers.index'));
            }
        }
    };

    deleteCustomer = (ev: any) => {
        ev.preventDefault();
        if (!confirm("Are you sure you want to delete this customer?")) {
            return;
        }
        this.setState({loading: true});
        postJson(resolveRoute('customers.delete', {id: this.state.formData.id}), {})
            .finally(() => {
                this.setState({loading: false});
            })
            .then((res: any) => {
                if (res.ok) {
                    if (this.props.afterSave) {
                        this.props.afterSave(res.data);
                    } else {
                        kb.notify({
                            text: 'Deleted',
                            className: 'success',
                        });
                        setTimeout(() => {
                            kb.navigate(resolveRoute('customers.index'));
                        }, 1000);
                    }
                } else if (res.data.errors) {
                    kb.notify({
                        html: RDS.renderToStaticMarkup(ErrorMessage({errors: res.data.errors})),
                        className: "warning",
                    });
                } else {
                    kb.notify({
                        text: "An unknown error occurred",
                        className: "error",
                    });
                }
            }, (err: any) => {
                kb.notify({
                    html: "A network error occurred. Please try a few more times!",
                    className: "error",
                });
            });
    };

    save = (ev: any) => {
        ev.preventDefault();
        this.setState({loading: true});
        postJson(resolveRoute('customers.store'), this.state.formData)
            .finally(() => {
                this.setState({loading: false});
            })
            .then((res: any) => {
                if (res.ok) {
                    if (this.props.afterSave) {
                        this.props.afterSave(res.data);
                    } else {
                        kb.notify({
                            text: 'Saved',
                            className: 'success',
                        });
                        setTimeout(() => {
                            if(res.data?.id) {
                                kb.navigate(resolveRoute('customers.show',{id:res.data.id}));
                            } else {
                                kb.navigate(resolveRoute('customers.index'));
                            }
                        }, 1000);
                    }
                } else if (res.data.errors) {
                    kb.notify({
                        html: RDS.renderToStaticMarkup(ErrorMessage({errors: res.data.errors})),
                        className: "warning",
                    });
                } else {
                    kb.notify({
                        text: "An unknown error occurred",
                        className: "error",
                    });
                }
            }, (err: any) => {
                kb.notify({
                    html: "A network error occurred. Please try a few more times!",
                    className: "error",
                });
            });
    }
}

interface MailAddress {
    placeName: string
    streetAddress: string
    city: string
    postalCode: string
    province: string
    country: string
}

function formatAddress(place: MailAddress) {
    let address = place.streetAddress ? place.streetAddress.trim() : '';

    if (place.placeName) {
        if (address) {
            address += ` (${place.placeName})`;
        } else {
            address = place.placeName;
        }
    }

    return [address, place.city, place.province, place.postalCode].filter(s => s).join(', ');
}
